module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/_fails.js
// module id = 4
// module chunks = 99